export enum EnumObject {
    ORGANIZATIONAL_UNIT = 'ORGANIZATIONAL UNIT',
    ORGANIZATION = 'ORGANIZATION',
    POSITION = 'POSITION',
    TITLE = 'TITLE',
    CADRE = 'CADRE',
    JOB = 'JOB',
    TASK = 'TASK',
    PERSONNEL = 'PERSONNEL',
    PERSON = 'PERSON',
}
